<!--component html goes here -->
<Label class="form-control-label" >{{label}}</Label>